module.exports = __webpack_public_path__ + "static/media/bg_kategooriad.a0e3b5ee.webp";